import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tabs from "../../CommonComponents/Tabs";
import Filters from "./Filterbtn";
import Table from "./Table";
import Pagination from "./Pagination";
import { useRollId } from "../../CommonComponents/RollIdContext";

const MainContent = ({ reload }) => {
  const { rollId } = useRollId();
  const location = useLocation();
  const [filters, setFilters] = useState({
    date: "",
    categoryType: "",
    currency: "",
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTP] = useState(0);

  useEffect(() => {
    setFilters({
      date: "",
      categoryType: "",
      currency: "",
    });
    setPage(1);
  }, [location.pathname]);

  return (
    <div className="container-fluid main-content-table bgColor d-flex flex-column overflow-hidden mt-2">
      <hr />

      <div className="flex-grow-1 d-flex flex-column pt-2">
        <div className="mt-2">
          <Filters filters={filters} setFilters={setFilters} />
        </div>
        <div
          className="table-wrapper marginRight flex-grow-1 p-3  rounded shadow-sm d-flex flex-column"
        >
          <div className="table-container scroll flex-grow-1" style={{ overflow: 'auto' }}>
            <Table
              reload={reload}
              filters={filters}
              setTotalPages={setTP}
              page={page}
              setPage={setPage}
            />
          </div>
          <div className="pagination-container mt-2 me-3">
            <Pagination totalPages={totalPages} page={page} setPage={setPage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
